import { render, staticRenderFns } from "./recordDetail2.vue?vue&type=template&id=53aceeb7&scoped=true&"
import script from "./recordDetail2.vue?vue&type=script&lang=js&"
export * from "./recordDetail2.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail2.vue?vue&type=style&index=0&id=53aceeb7&lang=scss&scoped=true&"
import style1 from "./recordDetail2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aceeb7",
  null
  
)

export default component.exports